import PrimaryButton from '@/components/Buttons/PrimaryButton';
import useInertiaData from '@/hooks/useInertiaData';
import useRoutes from '@/hooks/useRoutes';
import { GraduationCap, Play } from 'lucide-react';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

const ContinueLearning = () => {
    const { t } = useTranslation();

    const { user } = useInertiaData();

    if (!user?.last_class_viewed) {
        return null;
    }

    const lastClassViewed = useMemo(() => {
        return user.last_class_viewed;
    }, [user]);

    const lastCourseViewed = useMemo(() => {
        return user.last_course_viewed;
    }, [user]);

    if (!lastClassViewed || !lastCourseViewed) {
        return null;
    }

    const { route } = useRoutes();

    return (
        <div className="continue-learning-card">
            <div className="flex flex-col space-y-6 lg:flex-row lg:items-center lg:justify-between lg:space-y-0">
                <div className="flex-1 space-y-4">
                    <h1 className="text-2xl font-bold text-gray-900 sm:text-3xl">
                        {t('continueWhereYouLeftOff')}
                    </h1>
                    <p className="text-base text-gray-600 sm:text-lg">
                        {lastClassViewed.title}
                    </p>
                    <PrimaryButton
                        as="link"
                        href={route('class-detail', {
                            slug: lastCourseViewed.slug,
                            class_id: lastClassViewed.id.toString(),
                        }).toString()}
                        size="md"
                    >
                        <Play size={18} />
                        <span>{t('home.continueLearning')}</span>
                    </PrimaryButton>
                </div>
                <div className="hidden lg:ml-8 lg:block">
                    <div className="icon-container">
                        <GraduationCap
                            size={40}
                            className="text-white xl:h-12 xl:w-12"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ContinueLearning;
